import classNames from 'classnames';
import { useEffect, useState } from 'react';
import Modal, { ModalProps } from 'rsuite/lib/Modal';
import { ButtonPrimary, FileUpload, FileUploadInvalidPayload } from '../../../../../../../components';
import {
  BlocoDaVerbaNoArquivo,
  useVerbaNoArquivo,
} from '../../../NegociacaoFornecedor/components/Modals/CriarNegociacaoArquivo/BlocoDaVerbaNoArquivo';
import type { EscolhasDaVerbaNoArquivo } from '../../../NegociacaoFornecedor/verbaNoArquivo';
import styles from './UploadProdutosArquivoModal.module.scss';

const TEMPLATE_URL = 'https://s3.amazonaws.com/infoprice-prd-repository/ipa/file-negotiation/Template%20Upload%20de%20negocia%C3%A7%C3%A3o.xlsx';

export type UploadProdutosArquivoModalProps = ModalProps & {
  /** As escolhas vêm nulas quando a leitura do arquivo não voltou: sem ela não houve escolha a fazer. */
  onSubmit?: (file: File, escolhasDaVerba: EscolhasDaVerbaNoArquivo | null) => void;
  onHide?: () => void;
  onInvalidFile?: (payload: FileUploadInvalidPayload) => void;
};

/**
 * O modal que acrescenta produtos por arquivo a uma negociação que já existe.
 *
 * É o único fluxo em que existe arquivo novo sobre negociação que já tem verbas, e por isso ele
 * recebe **o mesmo bloco** do modal de criação -- e não uma segunda cópia dele, que divergiria.
 */
export const UploadProdutosArquivoModal = ({ className, onHide, onSubmit, onInvalidFile, show, ...props }: UploadProdutosArquivoModalProps) => {
  const [file, setFile] = useState<File | null>(null);

  const verba = useVerbaNoArquivo(file);

  useEffect(() => {
    if (!show) {
      setFile(null);
    }
  }, [show]);

  return (
    <Modal className={classNames('info-modal', styles['upload-produtos-arquivo-modal'], className)} onHide={onHide} show={show} {...props}>
      <form onSubmit={event => event.preventDefault()}>
        <Modal.Header>
          <div className={styles['modal-header']}>
            <Modal.Title className={styles['modal-title']}>Adicionar novos produtos por arquivo</Modal.Title>
            <p>Envie uma lista de preços para incluir ou atualizar produtos nesta negociação</p>
          </div>
        </Modal.Header>
        <Modal.Body className={styles['modal-body']}>
          <FileUpload value={file} onChange={setFile} onInvalidFile={onInvalidFile} templateUrl={TEMPLATE_URL} />

          <BlocoDaVerbaNoArquivo
            leitura={verba.leitura}
            estado={verba.estado}
            onDestino={verba.escolherODestino}
            onDestinoDasVazias={verba.escolherAsVazias}
            idDoGrupo="adicionar-produtos"
            className={styles['bloco-da-verba']}
          />
        </Modal.Body>
        <Modal.Footer>
          <ButtonPrimary skin="blue" theme="ghost" type="button" onClick={onHide}>
            CANCELAR
          </ButtonPrimary>
          <ButtonPrimary
            skin="blue"
            theme="filled"
            type="submit"
            disabled={!file}
            onClick={() => {
              if (!file) return;
              onSubmit?.(file, verba.escolhas);
            }}
          >
            SALVAR
          </ButtonPrimary>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
